import { Group, Button, Modal, Stack, Text, Title, Image } from '@mantine/core';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ConfirmeStartChatModal = (props: any) => {

    return (
        <Modal
            centered
            opened={props.opened}
            onClose={() => props.onClose()}
            withCloseButton={false}
            closeOnClickOutside={false}
        >
            <Stack>
                <Text align='center' color="primary" fz="lg" fw={700}>Start chat with this user?</Text>
                <Group sx={{ width: '100%' }} grow>
                    <Button onClick={() => props.onClose()}>
                        Cancel
                    </Button>
                    <Button
                        variant='outline'
                        onClick={() => props.onConfirm()}
                    >
                        <Group>
                            <Text>Start Chat</Text>
                            {/* <Group spacing={4} align="center">
                                <Text>5</Text>
                                <Image
                                    src={"/token.png"}
                                    height={16}
                                    width={16}
                                    style={{ marginRight: "4px" }}
                                />
                            </Group> */}
                        </Group>
                    </Button>
                    {/* <Button onClick={() => props.onConfirm()} color="red">
                        OK
                    </Button> */}
                </Group>
            </Stack>
        </Modal>
    );
};

export default ConfirmeStartChatModal;